import { useState } from 'react';

const InfoSection = () => {

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    request: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = 'Le prénom est requis';
    if (!formData.lastName) newErrors.lastName = 'Le nom est requis';
    if (!formData.email) newErrors.email = "L'email est requis";
    if (!formData.phone) newErrors.phone = 'Le téléphone est requis';
    if (!formData.request) newErrors.request = 'La demande est requise';
    if (!formData.message) newErrors.message = 'Le message est requis';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const recipients = process.env.REACT_APP_CONTACT_EMAIL;

    try {
      const response = await fetch('/api/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, recipients })
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ firstName: '', lastName: '', email: '', phone: '', request: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="py-12 px-12 bg-white">
      <div className="container mx-auto max-w-2xl">
        <h2 className="text-2xl font-bold mb-6 text-center">Nous contacter</h2>

        {status === 'success' && (
          <p className="text-green-600 text-center mb-4">Message envoyé avec succès !</p>
        )}
        {status === 'error' && (
          <p className="text-red-600 text-center mb-4">Erreur lors de l'envoi. Veuillez réessayer.</p>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex gap-4">
            <div className="flex-1">
              <input
                type="text"
                name="firstName"
                placeholder="Prénom *"
                value={formData.firstName}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
              {errors.firstName && <p className="text-red-500 text-sm">{errors.firstName}</p>}
            </div>
            <div className="flex-1">
              <input
                type="text"
                name="lastName"
                placeholder="Nom *"
                value={formData.lastName}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
              {errors.lastName && <p className="text-red-500 text-sm">{errors.lastName}</p>}
            </div>
          </div>

          <div>
            <input
              type="email"
              name="email"
              placeholder="Email *"
              value={formData.email}
              onChange={handleChange}
              className="w-full border p-2 rounded"
            />
            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
          </div>

          <div>
            <input
              type="tel"
              name="phone"
              placeholder="Téléphone *"
              value={formData.phone}
              onChange={handleChange}
              className="w-full border p-2 rounded"
            />
            {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}
          </div>

          <div>
            <select
              name="request"
              value={formData.request}
              onChange={handleChange}
              className="w-full border p-2 rounded text-gray-700"
            >
              <option value="">-- Objet de la demande *--</option>
              <optgroup label="Sujets de contact classiques">
                <option value="Demande d'information générale">Demande d'information générale</option>
                <option value="Test sortie du dimanche">Test sortie du dimanche</option>
                <option value="Adhésion à l'association">Adhésion à l'association</option>
                <option value="Questions sur un événement">Questions sur un événement</option>
                <option value="Partenariat / collaboration">Partenariat / collaboration</option>
                <option value="Proposition de projet">Proposition de projet</option>
              </optgroup>
              <optgroup label="Support & technique">
                <option value="Problème avec le site web">Problème avec le site web</option>
              </optgroup>
            </select>
            {errors.request && <p className="text-red-500 text-sm">{errors.request}</p>}
          </div>

          <div>
            <textarea
              name="message"
              placeholder="Message *"
              value={formData.message}
              onChange={handleChange}
              rows={5}
              className="w-full border p-2 rounded"
            />
            {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
          </div>

          <button
            type="submit"
            className="bg-[#DD7C88] text-white py-2 px-6 rounded hover:bg-[#c9697a] transition"
          >
            Envoyer
          </button>
        </form>
      </div>
    </section>
  );
};

export default InfoSection;
